import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import NavBar from "../navigation/navbar.js";
import Home from "../pages/home/home.js";
import Sandboxes from "../pages/sandboxes/sandboxes.js";
import CreatePage from "../pages/create/Create";
import Update from "../pages/update/update.js";
import AppContext, { AppContextInterface, defaultAppContextValue } from "../context/AppContext";

import "./app.css";
import { AxiosResponse } from "axios";
import { CognitoAuth } from "amazon-cognito-auth-js";
import { SandboxManagementClient } from "../client/sandbox-management-client";

const axios = require("axios");

interface AppState extends AppContextInterface {}

interface AppProps {}

interface Settings {
    cognitoDomain: string;
    cognitoClientId: string;
    domain: string;
    cognitoUserPoolId: string;
    sandboxManagementServiceApi: string;
}

class App extends Component<AppProps, AppState> {
    state = defaultAppContextValue;

    handleGetSettings(settings: AxiosResponse<Settings>) {
        const data = settings.data;
        const cognitoAuth = new CognitoAuth({
            AppWebDomain: data.cognitoDomain,
            ClientId: data.cognitoClientId,
            RedirectUriSignIn: data.domain,
            RedirectUriSignOut: data.domain,
            TokenScopesArray: ["openid", "email"],
            UserPoolId: data.cognitoUserPoolId,
        });

        const sandboxManagementClient = new SandboxManagementClient(data.sandboxManagementServiceApi, cognitoAuth);
        this.setState({ auth: cognitoAuth, sandboxManagementClient });
    }

    componentDidMount() {
        const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
        if (!isDev) {
            axios.get("/settings.json").then((r: AxiosResponse<Settings>) => this.handleGetSettings(r));
        }
    }

    render() {
        return (
            <AppContext.Provider value={this.state}>
                <Router>
                    <NavBar />
                    <Switch>
                        <Route exact path="/" component={Home} />
                        <Route exact path="/sandboxes" component={Sandboxes} />
                        <Route exact path="/create" component={CreatePage} />
                        <Route exact path="/update/" component={Update} />
                        <Route exact path="/update/:sandboxId" component={Update} />
                        <Redirect to="/" />
                    </Switch>
                </Router>
            </AppContext.Provider>
        );
    }
}

export default App;
